import React, { useEffect } from 'react';
import {
  Row,
  VertButton,
  VertCarousel,
  VertImage,
  VertTypography,
} from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Orders/OrderCardGift/OrderCardGift.less';
import generateUUID from 'Utils/generateUUID';
import { limitString } from 'Utils/commons/string';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { useNavigate } from 'react-router';
import { vi } from 'date-fns/locale';
import VertAccordionGift from 'components/VertAccordionGift';
import { Col, Typography } from 'antd';

// ORDER CARD INFO
const OrderCardGift = ({
  description,
  imageUrl,
  name,
  iventory,
  quantity,
  status,
  id,
  shppingDays,
  createdAt,
  shippingDate,
}) => {
  const item = {
    productImage: imageUrl,
    productName: name,
    vendorId: iventory,
    quantity: quantity,
    description: description,
  };
  const [convertedDate, setConvertedDate] = React.useState('');
  const navigate = useNavigate();
  useEffect(() => {
    const date = dayjs(createdAt)
      .locale('pt-br')
      .format('DD [de] MMMM [de] YYYY');
    setConvertedDate(date);
  }, [createdAt]);

  return (
    <>
      <div className="card-wrapper order-list-like">
        <div className="card-header">
          <span className="date-order"> {convertedDate}</span>
        </div>
        <div className="card-content">
          <Row
            key={generateUUID()}
            gutter={[16, 16]}
            className="order-card-gift-wrapper"
          >
            <Col key={generateUUID()} span={24} className="order-card-gift">
              <div className="order-card-gift-info">
                <div className="item-image">
                  <VertImage
                    src={item.productImage}
                    alt={item.productName}
                    preview={false}
                    placeholder="https://vertice-ds.s3.amazonaws.com/Assets/Images/fallbacks/fallback-img-store.png"
                    fallback="https://vertice-ds.s3.amazonaws.com/Assets/Images/fallbacks/fallback-img-store.png"
                  />
                </div>
                <div className="item-info">
                  <span className="item-name">{item.productName}</span>
                  <span className="item-quantity">Itens({item.quantity})</span>
                </div>
              </div>
              <VertTypography.Paragraph className="order-shipping-gift">
                <span className="order-shipping-title">
                  Previsão de entrega:
                </span>

                <span className="order-shipping-date">
                  {dayjs(shippingDate).locale('pt-br').format('DD/MM/YYYY')}
                </span>
              </VertTypography.Paragraph>
            </Col>
            <Col className="order-accordion" span={24}>
              <VertAccordionGift
                className="accordion-header gift-description-accordion"
                size="default"
                label="Características gerais"
              >
                <div>
                  <Typography.Text strong>Descrição: </Typography.Text>
                  <Typography.Text>{item.description}</Typography.Text>
                </div>
              </VertAccordionGift>
            </Col>
          </Row>

          <div className="order-value-wrapper"></div>
          <div className="order-details">
            <VertButton
              className="order-button-details"
              type="highlight"
              onClick={() => navigate(`/order-gift-details/${id}`)}
              style={{ visibility: 'hidden' }}
            >
              Exibir detalhes
            </VertButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderCardGift;
